import {AlertTriangle, RotateCcw} from 'lucide-react';
import {cn} from '@lib/utils';
import {Button} from '@ui/shadcn/button';
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@ui/shadcn/empty';

interface ErrorStateProps {
  title?: string;
  description?: string;
  /** Колбэк retry — если задан, кнопка «Повторить» отображается. */
  onRetry?: () => void;
  className?: string;
}

/**
 * Состояние ошибки запроса (обёртка над `shadcn/empty`). Параметр `onRetry`
 * обычно — `query.refetch`. Дизайн — компактная карточка с предупреждением;
 * не растягивается на всю высоту страницы.
 */
export const ErrorState = ({
  title = 'Не удалось загрузить данные',
  description = 'Попробуйте позже.',
  onRetry,
  className,
}: ErrorStateProps) => (
  <Empty
    role='alert'
    className={cn(
      'gap-3 rounded-xl border border-dashed border-[var(--score-bad)]/30 bg-[var(--score-bad-soft)]/40 px-4 py-10',
      className,
    )}
  >
    <EmptyHeader className='gap-1'>
      <EmptyMedia
        variant='icon'
        className='mb-2 size-9 rounded-full bg-[var(--score-bad-soft)] text-[var(--score-bad)]'
      >
        <AlertTriangle size={18} />
      </EmptyMedia>
      <EmptyTitle className='text-sm font-semibold'>{title}</EmptyTitle>
      {description && (
        <EmptyDescription className='max-w-[320px] text-xs'>
          {description}
        </EmptyDescription>
      )}
    </EmptyHeader>
    {onRetry && (
      <EmptyContent className='mt-1'>
        <Button
          variant='outline'
          size='sm'
          onClick={onRetry}
          className='border-[var(--score-bad)]/40 text-[var(--score-bad)] hover:bg-[var(--score-bad)] hover:text-white'
        >
          <RotateCcw size={11} />
          Повторить
        </Button>
      </EmptyContent>
    )}
  </Empty>
);
